module.exports = __webpack_public_path__ + "img/order_loading.98d2910b.gif";